import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.dto.streaming.FormStreamingQuery';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class FormStreamingQuery extends RpcClass{

    /**
     *  @class FormStreamingQuery
     *  @alias module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery
     *  
     * */
    constructor(){
        super();

        /** @type {string[]}  */
        this.activeColumns = null;
        /** @type {number}  */
        this.clusteringId = null;
        /** @type {string}  */
        this.dataClass = null;
        /** @type {string}  */
        this.detailsJoiningField = null;
        /** @type {string}  */
        this.detailsMasterClassLong = null;
        /** @type {number}  */
        this.detailsMasterId = null;
        /** @type {string}  */
        this.dynamicFilterSpec = null;
        /** @type {number[]}  */
        this.excludedIds = null;
        /** @type {boolean}  */
        this.filteringMode = null;
        /** @type {boolean}  */
        this.isDetail = null;
        /** @type {number}  */
        this.locateId = null;
        /** @type {Object.<string, string>}  */
        this.multicolumnSearch = null;
        /** @type {BigDecimal}  */
        this.numericQuery = null;
        /** @type {number}  */
        this.offset = null;
        /** @type {number[]}  */
        this.onlyIds = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/streaming/StreamingQueryColOrder.StreamingQueryColOrder[]}  */
        this.order = null;
        /** @type {string}  */
        this.queryCase = null;
        /** @type {string}  */
        this.rawColFilterSpec = null;
        /** @type {string}  */
        this.textQuery = null;
        /** @type {string}  */
        this.uuid = null;
        /** @type {string}  */
        this.viewLocateId = null;
        /** @type {number}  */
        this.windowSize = null;

    }





    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withActiveColumns(val){
        this.activeColumns = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withClusteringId(val){
        this.clusteringId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withDataClass(val){
        this.dataClass = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withDetailsJoiningField(val){
        this.detailsJoiningField = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withDetailsMasterClassLong(val){
        this.detailsMasterClassLong = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withDetailsMasterId(val){
        this.detailsMasterId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withDynamicFilterSpec(val){
        this.dynamicFilterSpec = val;
        return this;
    };


    /**
     * @param val {number[]}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withExcludedIds(val){
        this.excludedIds = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withFilteringMode(val){
        this.filteringMode = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withIsDetail(val){
        this.isDetail = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withLocateId(val){
        this.locateId = val;
        return this;
    };


    /**
     * @param val {Object.<string, string>}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withMulticolumnSearch(val){
        this.multicolumnSearch = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withNumericQuery(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.numericQuery = v;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withOffset(val){
        this.offset = val;
        return this;
    };


    /**
     * @param val {number[]}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withOnlyIds(val){
        this.onlyIds = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/streaming/StreamingQueryColOrder.StreamingQueryColOrder[]}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withOrder(val){
        this.order = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withQueryCase(val){
        this.queryCase = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withRawColFilterSpec(val){
        this.rawColFilterSpec = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withTextQuery(val){
        this.textQuery = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withUuid(val){
        this.uuid = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withViewLocateId(val){
        this.viewLocateId = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery}
     */
    withWindowSize(val){
        this.windowSize = val;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['activeColumns'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['clusteringId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['dataClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['detailsJoiningField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['detailsMasterClassLong'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['detailsMasterId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['dynamicFilterSpec'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['excludedIds'] = {'remoteType' : 'number[]', 'jsType' : 'number[]', 'mapped' : 'false'};
metadata['filteringMode'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isDetail'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['locateId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['multicolumnSearch'] = {'remoteType' : 'Object.<string, string>', 'jsType' : 'Object.<string, string>', 'mapped' : 'false'};
metadata['numericQuery'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['offset'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['onlyIds'] = {'remoteType' : 'number[]', 'jsType' : 'number[]', 'mapped' : 'false'};
metadata['order'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/streaming/StreamingQueryColOrder.StreamingQueryColOrder[]', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/streaming/StreamingQueryColOrder.StreamingQueryColOrder[]', 'mapped' : 'false'};
metadata['queryCase'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['rawColFilterSpec'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['textQuery'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['uuid'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['viewLocateId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['windowSize'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.rpc.dto.streaming.FormStreamingQuery';
metadata.__type_short__ = 'FormStreamingQuery';
FormStreamingQuery.prototype.__metadata__ = metadata;

FormStreamingQuery.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery */
export default FormStreamingQuery

export { FormStreamingQuery }
